
import React from 'react';
import ReactDOM from 'react-dom/client';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux'
import ReduxThunk from 'redux-thunk'
// import axios from 'axios';

import App from './User/App';
import 'leaflet/dist/leaflet.css';
// import config from './config';
import createRootReducer from './User/reducers';
import { doInit } from './User/actions/auth';



export const store = createStore(
    createRootReducer(),
    compose(
        applyMiddleware(
            ReduxThunk
        ),
    )
);

store.dispatch(doInit());

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
    <Provider store={store}>
        <App />
    </Provider>,
);
